import useSWR from 'swr';

import { generateApiPath, getCollection } from '#app/Handler/api';
import OrderClientEntryPoints from '#app/entrypoints/orderClient';
import { CarrierCode } from '#app/typings/carrier';

type Carrier = {
  code: CarrierCode;
  count: number;
};

type HookReturn = {
  carriers: Carrier[];
};

const useCarriersPreparing = (): HookReturn => {
  const { data: carriers } = useSWR<Carrier[]>(
    generateApiPath(OrderClientEntryPoints.getCollectionCarriersPreparer),
    getCollection,
    { refreshInterval: 20000 },
  );

  return {
    carriers: carriers ?? [],
  };
};

export default useCarriersPreparing;
